<div class="project-main-info">
  <div class="project-title limit-text">
    <a class="project-link" [routerLink]="['/project', project.id]">{{ project.name }}</a>
  </div>
  <app-status-badge [status]="project.status"></app-status-badge>
  <div class="project-location-wrapper content-horizontal-wrapper">
    <div class="content-horizontal-wrapper">
      <mat-icon>business_center</mat-icon>
      <span class="project-bu">{{ project.businessUnit }}</span>
    </div>
    <div class="content-horizontal-wrapper">
      <mat-icon>public</mat-icon>
      <div class="project-region">{{ project.region }}</div>
    </div>
    <div class="content-horizontal-wrapper">
      <mat-icon>pin_drop</mat-icon>
      <div class="project-country">{{ project.country }}</div>
    </div>
  </div>
  <div class="project-description limit-text desc">{{ project.description }}</div>
</div>
<div class="project-card-footer content-horizontal-wrapper">
  @if (projectInfo$ | async; as projectInfo) {
  <div class="content-horizontal-wrapper">
    <mat-icon>business</mat-icon>
    <span>{{ projectInfo.facilitiesNo }} facilities</span>
  </div>
  <div class="content-horizontal-wrapper">
    <mat-icon>memory</mat-icon>
    <div>{{ projectInfo.systemsNo }} systems</div>
  </div>
  <div class="content-horizontal-wrapper">
    <mat-icon>people</mat-icon>
    <div>{{ projectInfo.teamMembersNo }} members</div>
  </div>
  }
</div>
